<template>
  <el-row>
    <el-col :sm="12" :md="12" :lg="6" :xl="6" v-for="i in 16" :key="i">
      <div class="p-8 mb-20">
        <div class="flex-container p-4">
          <el-skeleton-item variant="circle" style="width: 60px; height: 60px" />
          <div class="mt-8 ml-8" style="width: 80%;">
            <el-skeleton-item variant="h1" />
            <el-skeleton-item variant="h1" />
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script setup>
</script>
